import React, { useState } from 'react';
import {
  Typography,
  makeStyles,
  Box,
  Tabs,
  Tab,
  Container,
  Dialog,
} from '@material-ui/core';
import AccountTab from './components/AccountTab';
import PreferencesTab from './components/PreferencesTab';
import OrderHistoryTab from './components/OrderHistoryTab';
// import { useAuth } from '../../contexts/AuthContext';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
  },
  tabPanel: {
    padding: theme.spacing(3, 0, 0, 0),
  },
}));

const Profile = () => {
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState(0);

  //   const { isAuthenticated, userData, loading, login, logout } = useAuth();

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Typography component="h1" variant="h5" gutterBottom>
        Profile
      </Typography>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="Account" />
        <Tab label="Order History" />
        <Tab label="Preferences" />
      </Tabs>
      <Box className={classes.tabPanel}>
        {activeTab === 0 && <AccountTab />}
        {activeTab === 1 && <OrderHistoryTab />}
        {activeTab === 2 && <PreferencesTab />}
      </Box>
    </Container>
  );
};

export default Profile;
